export function capitalizeLetters(string) {
  if (!string) return '';
  return string.toUpperCase();
}
